import { pagination, panel } from 'instantsearch.js/es/widgets'

/**
 * Load the pagination widgets.
 *
 * @param {Element} mainContainer The main search container.
 * @returns {Array} The stats widgets.
 */
export default function paginationWidgets( mainContainer ) {
  const widgets = []

  Array.from( mainContainer.querySelectorAll( '.js-instant-search-pagination' ) ).forEach(
    element => {
      // Prevent to show the pagination when only a page.
      const paginationWithPanel = panel({
        hidden( options ) {
          return options.results.nbPages === 1
        }
      })( pagination )

      widgets.push(
        paginationWithPanel({
          container: element,
          labels: {
            previous: element.dataset.previousLabel,
            next: element.dataset.nextLabel,
          },
          scrollTo: element.dataset.scrollto && true || false
        })
      )
    })

  return widgets
}
